<template>
    <div>
        <div class="head">
            <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/processManager/threeCard'}">应急卡</el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.params.key ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content">
            <el-form
                    :model="ruleForm"
                    :rules="rules"
                    ref="ruleForm"
                    label-width="120px"
                    class="demo-ruleForm"
                    style="width:60%;margin:0 auto"
                    size="small"
            >
                <el-form-item label="名称" prop="name">
                    <el-input v-model="ruleForm.name"></el-input>
                </el-form-item>
                <el-form-item label="编号" prop="number">
                    <el-input v-model="ruleForm.number"></el-input>
                </el-form-item>
                <el-form-item label-width="0">
                    <el-col :span="12">
                        <el-form-item label="部门/岗位" prop="value">
                            <el-cascader v-model="ruleForm.value" :options="options" @change="handleChange"
                                         style="width: 100%"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="部门领导" prop="leaderEmpId">
                            <el-select v-model="ruleForm.leaderEmpId" placeholder="请选择" style="width: 100%"
                                       @change="$forceUpdate()">
                                <el-option
                                        v-for="item in leaderEmpList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form-item>
                <el-form-item label="工艺附件" prop="craftFileUrl">
                    <el-upload
                            class="upload-demo"
                            action="/v1/certificate/uploadFile"
                            :on-remove="handleRemove"
                            :limit="1"
                            :on-success="uploadChange"
                            :on-exceed="handleExceed"
                            :file-list="fileList">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="步骤说明" prop="procedureExp">
                    <el-input type="textarea" :rows="4" v-model="ruleForm.procedureExp"/>
                </el-form-item>
                <el-form-item label="事故风险_事故后果" prop="accidentRisk">
                    <el-input type="textarea" :rows="4" v-model="ruleForm.accidentRisk"/>
                </el-form-item>
                <el-form-item label="发生场所" prop="place">
                    <el-input v-model="ruleForm.place"/>
                </el-form-item>
                <el-form-item label="危害描述" prop="harmDescribe">
                    <el-input v-model="ruleForm.harmDescribe" type="textarea" :rows="3"/>
                </el-form-item>
                <el-form-item label="应急处理政策" prop="emergencyProcessing">
                    <el-input v-model="ruleForm.emergencyProcessing" type="textarea" :rows="3"/>
                </el-form-item>
                <el-form-item label="内部应急电话" prop="interiorEmergencyCall">
                    <el-input v-model="ruleForm.interiorEmergencyCall" type="number"/>
                </el-form-item>
                <el-form-item label="外部应急电话" prop="externalEmergencyCall">
                    <el-input v-model="ruleForm.externalEmergencyCall" type="number"/>
                </el-form-item>
                <el-form-item label="附件">
                    <el-upload
                            class="upload-demo"
                            action="/v1/certificate/uploadFile"
                            :on-remove="handleRemove2"
                            :limit="1"
                            :on-success="uploadChange2"
                            :on-exceed="handleExceed2"
                            :file-list="fileList2">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div>
                <el-button type="primary" class="addBtn" @click="submitForm('ruleForm')">确定</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import {getDepartUser, addEmergeCard, updateEmergeCard} from '@/api/processManager'

    export default {
        data() {
            var validatePass = (rule, value, callback) => {
                if (this.ruleForm.craftFileUrl === undefined || this.ruleForm.craftFileUrl === '') {
                    callback(new Error('请上传文件'));
                } else {
                    callback();
                }
            };
            return {
                isAdd: true,
                dialogVisible: false,
                ruleForm: {
                    name: "",
                    content: "",
                    value: ""
                },
                rules: {
                    name: [{required: true, message: "请输入名称", trigger: "blur"}],
                    number: [{required: true, message: '请输入编号', trigger: 'blur'}],
                    value: [{required: true, message: "请选择部门", trigger: "blur"}],
                    leaderEmpId: [{required: true, message: "请选择部门领导", trigger: "blur"}],
                    procedureExp: [{required: true, message: "请输入步骤说明", trigger: "blur"}],
                    accidentRisk: [{required: true, message: "请输入事故风险_事故后果", trigger: "blur"}],
                    place: [{required: true, message: "请输入发生场所", trigger: "blur"}],
                    harmDescribe: [{required: true, message: "请输入危害描述", trigger: "blur"}],
                    emergencyProcessing: [{required: true, message: "请输入应急处理措施", trigger: "blur"}],
                    interiorEmergencyCall: [{required: true, message: "内部应急电话", trigger: "blur"}],
                    externalEmergencyCall: [{required: true, message: "外部应急电话", trigger: "blur"}],
                    craftFileUrl: [{required: true, validator: validatePass, trigger: 'change'}],
                },
                options: [],
                getObj: {},
                isShowBtn: true,
                isShowBtn2: true,
                emergeData: [],
                emergeData2: [],
                // 部门领导数组
                leaderEmpList: [],
                // 上传的两个数组
                fileList: [],
                fileList2: []
            };
        },
        methods: {
            handleChange(value) {
                if (this.ruleForm.depId != value[0]) {
                    this.ruleForm.depId = value[0]
                    this.leaderEmpList = [];
                    this.ruleForm.leaderEmpId = "";
                    // 获取部门领导
                    getDepartUser({demId: value[0]}).then(res => {
                        this.leaderEmpList = res.body.data;
                    });
                }
                this.ruleForm.jobId = value[1]
            },
            //获取部门信息
            getAllEmpInfo() {
                this.componentsMoudel.httpRequest
                    .getRequestHander(this.componentsMoudel.getData("urls").getAllEmplotee)
                    .openLoad()
                    .startGet()
                    .then(res => {
                        res.body.data.forEach(item => {
                            let obj = {value: item.id, label: item.name, children: []};
                            item.jobVos.forEach((items, indexs) => {
                                let newObj = {value: items.id, label: items.name};
                                obj.children.push(newObj);
                            });
                            this.options.push(obj);
                        });
                    });
            },
            // 上传的事件
            handleRemove(file, fileList) {
                this.fileList = fileList;
                this.ruleForm.craftFileUrl = ''
                this.ruleForm.craftFileName = ''
            },
            uploadChange(file, fileList) {
                this.fileList.push(fileList)
                this.$set(this.ruleForm, 'craftFileUrl', fileList.response.data)
                this.$set(this.ruleForm, 'craftFileName', fileList.name)
                this.$refs['ruleForm'].clearValidate('craftFileUrl')
            },
            handleExceed(file, fileList) {
                this.$message.warning('限制上传单个文件');
            },
            handleRemove2(file, fileList) {
                this.fileList2 = fileList;
                this.ruleForm.fileName = ''
                this.ruleForm.fileUrl = ''
            },
            uploadChange2(file, fileList) {
                this.fileList2.push(fileList)
                this.ruleForm.fileName = fileList.name
                this.ruleForm.fileUrl = fileList.response.data
            },
            handleExceed2(file, fileList) {
                this.$message.warning('限制上传单个文件');
            },
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        let obj = {...this.ruleForm}
                        delete obj.value
                        if (this.isAdd) {
                            addEmergeCard({...obj}).then(res => {
                                this.$message.success('添加成功')
                                this.$router.push({
                                    path: "/processManager/threeCard"
                                });
                            })
                        } else {
                            updateEmergeCard({...obj}).then(res => {
                                this.$message({
                                    showClose: true,
                                    message: "更新成功",
                                    type: "success"
                                });
                                this.$router.push({
                                    path: "/processManager/threeCard"
                                });
                            })
                        }
                    } else {
                        return false;
                    }
                });
            },
            close(index, val) {
                if (val === 1) {
                    let data = this.emergeData[index];
                    data.dialogVisible = false;
                    this.$set(this.emergeData, index, data);
                } else {
                    let data2 = this.emergeData2[index];
                    data2.dialogVisible = false;
                    this.$set(this.emergeData2, index, data2);
                }
            },
        },
        created() {
            this.getAllEmpInfo();
            let obj = this.$route.params.key;
            if (this.$route.params.key) {
                this.isAdd = false;
                this.getObj = obj;
                delete obj.gmtCreate
                this.ruleForm = {...obj};
                if (obj.fileUrl) {
                    this.fileList2.push({
                        name: obj.fileName,
                        response: {data: obj.fileUrl}
                    })
                }
                if (obj.craftFileUrl) {
                    this.fileList.push({
                        name: obj.craftFileName,
                        response: {data: obj.craftFileUrl}
                    })
                }
                // 获取部门领导
                getDepartUser({demId: obj.departmentVo.id}).then(res => {
                    this.leaderEmpList = res.body.data;
                });
                if (obj.departmentVo) {
                    this.$set(this.ruleForm, "value", [obj.departmentVo.id, obj.jobId]);
                }
            } else {
                this.ruleForm = {};
            }
            // this.isShowBtn = false;
            // console.log(this.emergeData)
        },
        deactivated() { //路由组件失活时时执行函数
            this.$destroy() //路由组件失活时 销毁组件 再次打开重载组件
        }
    };
</script>

<style scoped>
    .addBtn {
        display: block;
        width: 300px;
        margin: 0 auto;
    }

    .myHead {
        position: absolute;
        top: 0px;
        left: 250px;
        width: 80%;
        height: 160px;
    }

    .el-divider__text {
        font-size: 20px !important;
    }
</style>
